import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormControl, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { FormValidationService } from "src/app/core/services/form-validation.service";
import { FocusPayApplication } from "src/app/shared/models/FocusPay/FocusPayApplication.item";

@Component({
	selector: "app-application-business-info",
	templateUrl: "./application-business-info.component.html",
	styleUrls: ["../../focuspay.style.scss"],
})
export class ApplicationBusinessInfoComponent implements OnInit {
	@Input() application: FocusPayApplication;
	@Input() readOnly: boolean;
	@Output() applicationEmitter = new EventEmitter<FocusPayApplication>();

	@Output() displayModal = new EventEmitter<string>();
	@Output() inputActionEmitter = new EventEmitter<any>();
	@Output() sectionCompleteEmitter = new EventEmitter<any>();
	sectionStatus: Subject<any> = new Subject<any>();

	businessAgeValues = [
		{
			label: "Brand new business",
			value: 0,
		},
		{
			label: "1 to 3 years",
			value: 2,
		},
		{
			label: "3 to 5 years",
			value: 4,
		},
		{
			label: "5 to 10 years",
			value: 7,
		},
		{
			label: "10 or more years",
			value: 10,
		},
	];

	estimatedAverageTicketControl: UntypedFormControl;

	estimatedTicketValues = [
		{
			label: "$0 - $10",
			value: 10.0,
		},
		{
			label: "$10 - $50",
			value: 35.0,
		},
		{
			label: "$50 - $100",
			value: 75.0,
		},
		{
			label: "$100+",
			value: 150.0,
		},
	];
	estimatedVolumeControl: UntypedFormControl;
	estimatedVolumeValues = [
		{
			label: "less than $12,000 /month",
			value: 12000.0,
		},
		{
			label: "$12,000 - $30,000 /month",
			value: 20000.0,
		},
		{
			label: "$30,000 - $60,000 /month",
			value: 45000.0,
		},
		{
			label: "$60,000 - $100,000 /month",
			value: 80000.0,
		},
		{
			label: "more than $100,000 /month",
			value: 150000.0,
		},
	];

	sectionComplete: boolean = false;

	yearsInBusinessControl: UntypedFormControl;
	yearsOfCurrentOwnershipControl: UntypedFormControl;

	constructor(public validator: FormValidationService) {}

	ngOnInit(): void {
		this.yearsInBusinessControl = new UntypedFormControl({ value: this.application.yearsInBusiness, disabled: this.readOnly }, [Validators.required]);
		this.yearsOfCurrentOwnershipControl = new UntypedFormControl({ value: this.application.yearsOfCurrentOwnership, disabled: this.readOnly }, []);
		this.estimatedAverageTicketControl = new UntypedFormControl({ value: this.application.estimatedAverageTicket, disabled: this.readOnly }, [
			Validators.required,
		]);
		this.estimatedVolumeControl = new UntypedFormControl({ value: this.application.estimatedVolume, disabled: this.readOnly }, [Validators.required]);
		setTimeout(() => {
			this.inputAction();
		}, 500);
	}

	inputAction(inputEvent?) {
		inputEvent && this.inputActionEmitter.emit(inputEvent);
		this.sectionStatus.next({
			section: "business",
			complete: false,
		});
		this.sectionComplete = false;
		if (!this.estimatedAverageTicketControl.pristine && this.estimatedAverageTicketControl.errors) return;
		if (!this.estimatedVolumeControl.pristine && this.estimatedVolumeControl.errors) return;
		if (!this.yearsInBusinessControl.pristine && this.yearsInBusinessControl.errors) return;
		if (!this.yearsInBusinessControl.pristine && this.yearsInBusinessControl.errors) return;

		this.sectionComplete = true;
		this.sectionStatus.next({
			section: "business",
			complete: true,
		});
	}

	setBusinessAge() {
		setTimeout(() => {
			this.businessAgeValues.forEach((age) => {
				if (age.value > this.application.yearsInBusiness) {
					age["disabled"] = true;
				}
			});
		}, 50);
	}
}
